<div *ngIf="hasLoaded" class="full-height static-map">
  <google-map
    class="static-map__browser"
    [center]="location"
    [zoom]="zoom"
    [options]="options"
    disableDefaultUI="true"
  >
    <map-marker
      [position]="location"
      [options]="{icon: icon}"
    >
    </map-marker>
  </google-map>
  <ion-fab class="static-map__fab" *ngIf="showFabButton">
    <ion-fab-button color="smooth-dark" (click)="openGoogleMap()">
      <img src="assets/images/pin.svg" alt="pin" />
    </ion-fab-button>
  </ion-fab>
</div>
